import { useMobileAppState } from 'lib/hooks/useMobileAppState';
import Script from 'next/script';

const SmartBanner = () => {
  const { isMobileApp } = useMobileAppState();

  if (isMobileApp) {
    return null;
  }

  return <Script src="/scripts/smartBanner.js" strategy="lazyOnload" />;
};

export const standalone = SmartBanner;

export default SmartBanner;
